import './conversation_list.less';

import * as Business                     from '../business';
import { AutoSizer, List }               from 'react-virtualized';
import { useMemo }                       from 'react';
import Conditional                       from '../components/conditional';
import ConversationItem                  from './conversation_item';
import FilteredList                      from '../components/filtered_list';
import fuseOptions                       from './fuse_options';
import PreventPullToRefreshWhenScrolling from '../components/prevent_pull_to_refresh_when_scrolling';
import React                             from 'react';


export default function ConversationList({
  businessID,
  conversationID,
  currentUserID,
  isNPS,
  conversations,
  query
}) {
  const team       = Business.useTeam(businessID);
  const collection = useMemo(() => {
    return conversations.map(conversation => addTeamNamesToConversation(conversation, team));
  }, [ conversations, team ]);

  return (
    <FilteredList {...{
      query,
      fuseOptions,
      collection,
      emptyView: <NoSearchResults {...{ query }}/>
    }}>
      {items => <VirtualList {...{ items, businessID, conversationID, currentUserID, isNPS }}/>}
    </FilteredList>
  );
}


export function addTeamNamesToConversation(conversation, team) {
  const assignees    = conversation?.assignees ?? [];
  const participants = conversation?.participants ?? [];

  return {
    ...conversation,
    participants: addUserNames(participants),
    assignees:    addUserNames(assignees)
  };

  function addUserNames(list) {
    return list.map(item => {
      return {
        ...item,
        user: {
          id:   item.user.id,
          name: getUserName(item.user.id)
        }
      };
    });
  }

  function getUserName(userID) {
    const teamUser = team?.users.find(u => u.id === userID);
    return teamUser?.name;
  }
}


function VirtualList({ items, businessID, conversationID, currentUserID, isNPS }) {
  return (
    <div className="conversation-list">
      <PreventPullToRefreshWhenScrolling>
        {({ onScroll }) => (
          <AutoSizer>
            {({ width, height }) => (
              <List
                width={width}
                height={height}
                rowCount={items.length + 1} // add one row for padding at the bottom of the list
                rowHeight={101}
                rowRenderer={getRowRenderer({ items, businessID, conversationID, currentUserID, isNPS })}
                scrollToAlignment="start"
                onScroll={onScroll}
              />
            )}
          </AutoSizer>
        )}
      </PreventPullToRefreshWhenScrolling>
    </div>
  );
}


function getRowRenderer({ items, businessID, conversationID, currentUserID, isNPS }) {
  return function rowRenderer({ key, index, style }) {
    const conversation = items[index];
    return (
      <Conditional key={key} condition={conversation}>
        <ConversationItem {...{ businessID, conversationID, currentUserID, isNPS, conversation, style }}/>
      </Conditional>
    );
  };
}


function NoSearchResults({ query }) {
  return (
    <div className="no-search-results">
      <h3 className="title">Nothing found</h3>
      <p className="subtitle">No results found for &quot;{query}&quot;.</p>
    </div>
  );
}
